const initialstate = {
  fetching: null,
  fetchingSuccessful: null,
  fetchingFailed: null,
  error: null,
  errorText: null,
  prompts: null,
};

const getDefaultPromptsReducer = (state = initialstate, action) => {
  switch (action.type) {
    case 'FETCHING_DEFAULT_PROMPTS':
      return Object.assign({}, state, {
        fetching: true,
      });
    case 'FETCHING_DEFAULT_PROMPTS_DONE':
      return Object.assign({}, state, {
        fetching: false,
        fetchingSuccessful: true,
        fetchingFailed: false,
        error: false,
        errorText: '',
        prompts: action.payload,
      });
    case 'FETCHING_DEFAULT_PROMPTS_FAILED':
      return Object.assign({}, state, {
        fetching: false,
        fetchingSuccessful: false,
        fetchingFailed: true,
        error: true,
        errorText: action.payload,
        prompts: {},
      });
    default:
      return state;
  }
};

export default getDefaultPromptsReducer;
